import React, { PropsWithChildren } from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Form } from '@/components/ui/form';

import CompanyFormStepView from './view';
import { ICompanyFormSchema, companySchema } from './schema';

interface IProps extends PropsWithChildren {
  defaultValues?: DefaultValues<ICompanyFormSchema>;
  onSubmit: SubmitHandler<ICompanyFormSchema>;
}

const CompanyFormStep: React.FC<IProps> = ({
  defaultValues,
  onSubmit,
  children,
}) => {
  const form = useForm<ICompanyFormSchema>({
    defaultValues,
    resolver: zodResolver(companySchema),
  });

  return (
    <Form {...form}>
      <CompanyFormStepView
        control={form.control}
        isLoading={form.formState.isSubmitting}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        {children}
      </CompanyFormStepView>
    </Form>
  );
};

export default CompanyFormStep;
